function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import { TokenBucket } from "./TokenBucket";
export var BucketRateLimiter = /*#__PURE__*/ function() {
    "use strict";
    function BucketRateLimiter(bucketCapacity, bucketFillRate, onKeyFirstRateLimited) {
        _classCallCheck(this, BucketRateLimiter);
        this.buckets = new Map();
        this.rateLimitedKeys = new Set();
        this.defaultBucketCapacity = bucketCapacity;
        this.defaultBucketFillRate = bucketFillRate;
        this.onKeyFirstRateLimited = onKeyFirstRateLimited;
    }
    _createClass(BucketRateLimiter, [
        {
            key: "canCall",
            value: function canCall(key) {
                if (!this.buckets.has(key)) {
                    this.buckets.set(key, new TokenBucket(this.defaultBucketCapacity, this.defaultBucketFillRate));
                }
                var bucket = this.buckets.get(key);
                var hasEnoughTokens = bucket.removeToken();
                // Call a callback the first time a key has been rate limited.
                if (!hasEnoughTokens && !this.rateLimitedKeys.has(key)) {
                    var _obj, ref;
                    this.rateLimitedKeys.add(key);
                    (ref = (_obj = this).onKeyFirstRateLimited) === null || ref === void 0 ? void 0 : ref.call(_obj, key, bucket.numTokens);
                }
                return hasEnoughTokens;
            }
        }
    ]);
    return BucketRateLimiter;
}();
